import React from "react";
import ScrollToTop from "../components/ScrollToTop";
import Gallery from "../components/Gallery";

const GalleryPage = () => {
  return (
    <>
      <ScrollToTop />
      <Gallery />
    </>
  );
};

export default GalleryPage;
